import React from 'react';
import styles from './ConfirmCancelDialog.module.css';

interface ConfirmCancelDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isCanceling?: boolean;
  error?: string | null;
}

export const ConfirmCancelDialog: React.FC<ConfirmCancelDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isCanceling = false,
  error,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={isCanceling ? undefined : onCancel}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <h3 className={styles.title}>Cancel Session</h3>
        <p className={styles.message}>Are you sure you want to cancel this session? This action cannot be undone.</p>
        {error ? (
          <div className={styles.errorMessage}>
            <p>{error}</p>
          </div>
        ) : null}
        <div className={styles.actions}>
          <button type="button" className={styles.cancelButton} onClick={onCancel} disabled={isCanceling}>
            Keep Session
          </button>
          <button type="button" className={styles.confirmButton} onClick={onConfirm} disabled={isCanceling}>
            {isCanceling ? 'Canceling...' : 'Cancel Session'}
          </button>
        </div>
      </div>
    </div>
  );
};
